import RobustWebSocket from 'robust-websocket';

// maybe we can send url domain of parent that included
// iframe
const ws = new RobustWebSocket('ws://machines.flowfactories.com:5000/flipz');
//const ws = new RobustWebSocket('ws://localhost:5000/flipz');
let uuid;

//legacy fallback
function uuidv4() {
    return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c =>
      (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
    );
}

function generateUUID() { // Public Domain/MIT
    var d = new Date().getTime();//Timestamp
    var d2 = ((typeof performance !== 'undefined') && performance.now && (performance.now()*1000)) || 0;//Time in microseconds since page-load or 0 if unsupported
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = Math.random() * 16;//random number between 0 and 16
        if(d > 0){//Use timestamp until depleted
            r = (d + r)%16 | 0;
            d = Math.floor(d/16);
        } else {//Use microseconds since page-load if supported
            r = (d2 + r)%16 | 0;
            d2 = Math.floor(d2/16);
        }
        return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
    });
}


// Prüfen ob sessionStorage.color existiert 
if ("uuid" in sessionStorage) {
    uuid = sessionStorage.uuid;
} else 
{
    //uuid = "4711";
    if (window.isSecureContext) {
    uuid = self.crypto.randomUUID();
    } else { uuid = "x"+generateUUID(); }
    sessionStorage.setItem ("uuid", uuid);
}

ws.addEventListener('open', function (event) { connect_event('id',uuid) });
//ws.addEventListener('uuid', function (event) { uuid_event('id',uuid) });

function enqueue_event(name, args) {
    args = { 'event': 'enqueue_event', 'name': name, 'args': args };
    console.log(args);
    ws.send(JSON.stringify(args));
}

function connect_event(name, args) {
    args = { 'event': 'connection', 'name': name, 'args': args };
    console.log(args);
    ws.send(JSON.stringify(args));
}

function uuid_event(name, args) {
    args = { 'event': 'id_echo', 'name': name, 'args': args };
    console.log(args);
    ws.send(JSON.stringify(args));
}

export { ws, enqueue_event };
//export { ws, connect_event };